(function () {
  if (!('sessionStorage' in window)) return;

  // Take over scroll restoration from the browser so it doesn't fight ours.
  // Note: with 'manual', Safari also stops auto-restoring on bfcache, so we
  // must always restore ourselves on pageshow.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  var KEY_PREFIX = 'tok:scroll:';
  var key = function () {
    return KEY_PREFIX + location.pathname + location.search;
  };

  var getY = function () {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  };

  var save = function () {
    try {
      sessionStorage.setItem(key(), String(getY()));
    } catch (e) {}
  };

  window.addEventListener('pagehide', save);
  // iOS Safari doesn't always fire pagehide when the user switches apps.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  var isBackForward = function (event) {
    if (event.persisted) return true; // bfcache restore
    var nav =
      performance.getEntriesByType &&
      performance.getEntriesByType('navigation')[0];
    return !!(nav && nav.type === 'back_forward');
  };

  var restore = function (target) {
    var attempts = 0;
    var maxAttempts = 90; // ~1.5s @60fps
    var aborted = false;

    // Abort the moment the user expresses intent to scroll, so we never
    // fight a real touch/wheel/key input.
    var abort = function () {
      aborted = true;
    };
    var onKey = function (e) {
      var k = e.key;
      if (
        k === 'ArrowUp' ||
        k === 'ArrowDown' ||
        k === 'PageUp' ||
        k === 'PageDown' ||
        k === 'Home' ||
        k === 'End' ||
        k === ' ' ||
        k === 'Spacebar'
      ) {
        aborted = true;
      }
    };
    var listenerOpts = { passive: true };
    window.addEventListener('wheel', abort, listenerOpts);
    window.addEventListener('touchmove', abort, listenerOpts);
    window.addEventListener('keydown', onKey);
    var cleanup = function () {
      window.removeEventListener('wheel', abort, listenerOpts);
      window.removeEventListener('touchmove', abort, listenerOpts);
      window.removeEventListener('keydown', onKey);
    };

    // First attempt. If the page is already tall enough we're done in one shot.
    window.scrollTo(0, target);
    if (getY() >= target - 2) {
      cleanup();
      return;
    }

    // Otherwise wait for content (lazy-loaded images, etc.) to grow tall enough,
    // then scroll exactly once more. We do NOT call scrollTo every frame — that
    // would override the user's own scrolling during the wait.
    var step = function () {
      if (aborted || attempts >= maxAttempts) {
        cleanup();
        return;
      }
      var maxScroll =
        Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        ) - window.innerHeight;
      if (maxScroll >= target) {
        window.scrollTo(0, target);
        cleanup();
        return;
      }
      attempts++;
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  var tryRestore = function (event) {
    if (!isBackForward(event)) return;
    var raw;
    try {
      raw = sessionStorage.getItem(key());
    } catch (e) {
      return;
    }
    if (raw === null) return;
    var target = parseInt(raw, 10);
    if (isNaN(target) || target <= 0) return;
    restore(target);
  };

  window.addEventListener('pageshow', tryRestore);
})();
